import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function UnblockModal({ cancelModal, profile, fetchData }) {
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  //styled

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      const unblockResponse = await axios.put(
        `${ApiConnectionString}/api/convo/Unblock/${profile.id}`,
        null,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (unblockResponse.status === 200) {
        setComplete(true);
        fetchData();
      } else {
        // Handle unexpected status codes if needed
        console.error("Unexpected response status:", unblockResponse.status);
      }
    } catch (error) {
      // Handle errors
      console.error("Error during unblock:", error);
    } finally {
      // Always stop loading, regardless of success or failure
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">User Unblocked</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <p>You have unblocked {profile.username}.</p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">User Unblocked</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>Are you sure that you want to unblock {profile.username}?</p>

            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleConfirm}>
                Confirm
              </button>

              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
